<template>
  <div class="container mx-auto">
    <div class="text-left content card">
      <div class="page-header row mb-3">
        <div class="col">
          <label for="mesSelecionado">
            <b>Mês de faturamento</b>
          </label>
          <b-input-group>
            <select
              name="mesSelecionado"
              id="mesSelecionado"
              v-model="mesSelecionado"
              class="form-control"
            >
              <option :value="key" v-for="(item, key) in meses" :key="key">{{item}}</option>
            </select>
            <b-input-group-append class="col-sm-2">
              <select
                name="anoSelecionado"
                id="anoSelecionado"
                v-model="anoSelecionado"
                class="form-control"
              >
                <option :value="item" v-for="item in anos" :key="item">{{item}}</option>
              </select>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="secondary btn-sm" @click="onSearch()">Buscar clientes</b-button>
            </b-input-group-append>
            <b-input-group-append v-if="list.length > 0 && buscaFeita">
              <b-button variant="primary btn-sm" @click="downloadPdf()">Download PDF</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div class="alert alert-warning" v-if="list.length == 0 && buscaFeita">Nenhum envio nesse mês</div>

      <div class="alert alert-danger" v-if="erro">{{erroMsg}}</div>

      <div class="alert alert-info" v-if="buscando">{{log}}</div>

      <div class="row" v-if="list.length > 0">
        <div class="col-12">
          <div class="card shadow p-3 mt-2 card-table-header">
            <div class="row">
              <div class="col-4">Grupo</div>
              <div class="col-4">Clientes no grupo</div>
              <div class="col">Total de arquivos</div>
              <div class="col text-sm-left text-md-right">Opção</div>
            </div>
          </div>

          <div
            v-for="item in list"
            :key="item._id"
            class="card shadow p-3 mt-2"
            :class="{ 'processado' :faturado(item._id)}"
          >
            <div class="row">
              <div class="col-4">{{item.nome}}</div>
              <div class="col">{{item.clientes | number}}</div>
              <div class="col">{{item.totalArquivos | number}}</div>
              <div class="col text-sm-left text-md-right">
                <b-button
                  variant="sm btn-secondary"
                  @click="faturar(item)"
                  class="col-md-auto col-xs-12"
                >Faturar</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import jsPDF from "jspdf";

import EventBus from "./../core/eventBus";

import FaturamentoModal from "./FaturamentoModal";

export default {
  data() {
    return {
      buscaFeita: false,
      buscando: false,
      erro: false,
      erroMsg: '',
      log: false,
      list: [],
      faturados: [],
      totalItens: 0,
      mesSelecionado: moment().month(),
      anoSelecionado: moment().format("YYYY"),
      anos: [
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025"
      ],
      meses: {
        0: "Janeiro",
        1: "Fevereiro",
        2: "Março",
        3: "Abril",
        4: "Maio",
        5: "Junho",
        6: "Julho",
        7: "Agosto",
        8: "Setembro",
        9: "Outubro",
        10: "Novembro",
        11: "Dezembro"
      }
    };
  },
  sockets: {
    logBuscaClientesFinanceiro(data) {
      if (data.final) {
        this.list = data.resumo;
        this.log = false;
        this.buscando = false;
        this.buscaFeita = true;
      } else {
        this.log = data.msg;
      }
    },
  },
  methods: {
    downloadPdf() {
      const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
        pagesplit: true
      });

      let pageHeight = doc.internal.pageSize.height;

      let spacing = 20;

      doc.text(
        `Lista de clientes que enviaram no mes de ${
          this.meses[this.mesSelecionado]
        }`,
        10,
        spacing
      );

      doc.setFontSize(10);
      spacing += 10;

      let somarNaProxima = 0;

      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        const stringPraEscreve = `${i} - ${item.nome} - ${item.totalArquivos} arquivos`;
        spacing += 10 + somarNaProxima;

        if (somarNaProxima > 0) somarNaProxima = 0;

        for (let j = 0; j < item.clientesDoGrupo.length; j++) {
          const cliente = item.clientesDoGrupo[j];
          stringPraEscreve += `
               ${cliente.nome}`;
          somarNaProxima += 5;
        }

        if (spacing + 10 >= pageHeight) {
          spacing = 10;
          doc.addPage();
        }

        doc.text(stringPraEscreve, 10, spacing);
      }

      doc.save(
        `Lista_CLientes_${this.meses[this.mesSelecionado]}_${
          this.anoSelecionado
        }.pdf`
      );
    },
    faturado(id) {
      return this.faturados.indexOf(id) > -1;
    },
    async faturar(grupo) {
      const windowW = window.innerWidth <= 1024 ? "95%" : "60%";

      this.$modal.show(
        FaturamentoModal,
        {
          grupo,
          mes: this.meses[this.mesSelecionado],
          mesIndex: this.mesSelecionado,
          ano: this.anoSelecionado
        },
        {
          clickToClose: false,
          scrollable: true,
          adaptive: true,
          height: "auto",
          width: windowW,
          scrollable: true
        }
      );
    },
    async onSearch() {
      this.list = [];
      this.buscando = true;
      this.buscaFeita = false;
      this.erroMsg = false;
      this.erro = false;
      this.log = "Enviando requisição, aguarde...";
      const resposta = await this.$http.get(
        `/v1/financeiro/faturamento/getClientesEnvio/${this.mesSelecionado}/${this.anoSelecionado}`
      );

      if (resposta.success === false) {
        this.erroMsg = resposta.err;
        this.erro = true;
        this.buscando = false;
        this.buscaFeita = false;
        this.log = "";
      }
    }
  },
  mounted() {
    const app = this;
    EventBus.$on("clienteFaturado", async data => {
      app.faturados.push(data);
    });
  }
};
</script>

<style >
.processado {
  background: rgb(190, 238, 183);
  background: linear-gradient(
    90deg,
    rgba(190, 238, 183, 1) 0%,
    rgba(90, 233, 152, 1) 100%
  );
  color: darkgreen;
}
</style>
